export const PROFILE_DEFAULT_TAB = "expediente";

export const getProfileTabPaneClass = (
  isTabActive?: boolean,
  embedded?: boolean
) =>
  embedded
    ? "profile-panel-pane"
    : `tab-pane fade${isTabActive ? " active show" : ""}`;
